import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useRecoilState } from 'recoil';
import CreateAppointment from './CreateAppointment';
import { useAppointmentLabels } from '../../../App/customize/hooks/useAppointmentLabels';
import { createAppointmentModalStateAtom } from '../../../modals/CreateAppointment/CreateAppointmentModal.state';
import { useCreateAppointmentModal } from '../../../modals/CreateAppointment/CreateAppointmentModal.hooks';

const CreateAppointmentModal = () => {
  const labels = useAppointmentLabels();
  const [modalState] = useRecoilState(createAppointmentModalStateAtom);
  const { closeCreateAppointmentModal } = useCreateAppointmentModal();

  if (!modalState.open) {
    return null;
  }

  return (
    <Modal
      isOpen
      size="xl"
      className="model-form create-appointment-modal"
      toggle={closeCreateAppointmentModal}
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader className="header-form">
        {labels.newAppointment}
      </ModalHeader>
      <ModalBody>
        <CreateAppointment noCard onCancel={closeCreateAppointmentModal} />
      </ModalBody>
    </Modal>
  );
};

export default CreateAppointmentModal;
